import SectionHead from "./SectionHead";
import { heatRanking } from "@/mocks/homeData";

function trendStyle(trend: string) {
  if (trend === "up") return { icon: "ri-arrow-up-line", color: "text-primary-600" };
  if (trend === "down") return { icon: "ri-arrow-down-line", color: "text-secondary-600" };
  return { icon: "ri-sparkling-2-line", color: "text-accent-600" };
}

export default function HeatRanking() {
  return (
    <section
      id="ranking"
      className="border-y border-background-200 bg-background-100 px-4 py-12 md:px-10 md:py-16"
    >
      <SectionHead
        index="02"
        title="热度榜"
        en="Heat Ranking"
        desc="按站内检索、讨论与转发综合排序，每十分钟刷新一次。趋势比名次更值得看。"
      />

      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <div className="rounded-lg border border-background-300 bg-background-50 p-6">
            <div className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.25em] text-accent-700">
              <i className="ri-fire-fill" />
              本期榜首
            </div>
            <div className="mt-4 font-heading text-4xl font-black text-foreground-950">96</div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              榜首话题的热度来自连续三次新增，讨论并未集中在单一角度，而是分散在多个分支标签里。
            </p>
            <div className="mt-5 flex items-center gap-2 border-t border-background-200 pt-4 font-label text-xs text-foreground-500">
              <i className="ri-time-line" />
              最近刷新 · 11:02
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="flex items-center justify-between border-b border-background-300 pb-3 font-label text-[11px] uppercase tracking-[0.2em] text-foreground-400">
            <span>话题 / 分类</span>
            <span className="hidden sm:block">热度指数</span>
          </div>

          {heatRanking.map((item) => {
            const trend = trendStyle(item.trend);
            const isTop = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#ranking"
                className="group flex cursor-pointer items-center gap-4 border-b border-background-200 py-5 last:border-0"
              >
                <span
                  className={`w-8 shrink-0 font-heading text-xl font-black md:text-2xl ${
                    isTop ? "text-accent-600" : "text-background-500"
                  }`}
                >
                  {String(item.rank).padStart(2, "0")}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h4 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </h4>
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[10px] text-secondary-900">
                      {item.category}
                    </span>
                  </div>
                  <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`heat-bar h-full rounded-full ${
                        isTop ? "bg-primary-500" : "bg-foreground-300"
                      }`}
                      style={{ width: `${item.heat}%` }}
                    />
                  </div>
                </div>

                <div className="w-16 shrink-0 text-right">
                  <div className="font-heading text-lg font-black text-foreground-950">{item.heat}</div>
                  <div className={`flex items-center justify-end gap-1 font-label text-[11px] ${trend.color}`}>
                    <i className={trend.icon} />
                    <span className="whitespace-nowrap">{item.delta}</span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}